const PlaceType = {
  LOAD: 'place/load',
};

export default PlaceType;
